module.exports = __webpack_public_path__ + "static/media/big-neon-search-userflow.368cb758.jpg";